import { ImageField, LinkField, StringField } from "../../../types/types";
import { ContentHubSpecialOffersProps, ContentHubSpecialOffersRendererFields, ContentHubSpecialOffersSlideFields, } from "./fields.definitions";

export class ContentHubSpecialOffersModel {
    private readonly fields: null | ContentHubSpecialOffersRendererFields;
    constructor(props: ContentHubSpecialOffersProps) {
        this.fields = props.fields || null;
    }

    get eyebrow(): StringField {
        return { value: this.fields?.apiData?.eyebrow }
    }

    get title(): StringField {
        return { value: this.fields?.apiData?.title };
    }

    get description(): StringField {
        return { value: this.fields?.apiData?.description };
    }

    get items() {
        let items: ContentHubSpecialOffersSlideFields[] = this.fields?.apiData?.items || [];
        const defaultValue = items && items.map((Card, index) => {
            return new ContentHubSpecialOffersSlideModel(Card, index);
        });
        if (this.fields && this.fields['Cards']) {
            return this.fields['Cards'].map((Card, index) => {
                return new ContentHubSpecialOffersSlideModel(Card, index);
            });;
        }
        return defaultValue;
    }
}

export class ContentHubSpecialOffersSlideModel {
    private readonly card: ContentHubSpecialOffersSlideFields;
    private readonly itemIndex: number;
    constructor(Card, index) {
        this.card = Card || null;
        this.itemIndex = index;
    }

    get title(): StringField {
        return { value: this.card?.title };

    }

    get discount(): StringField {
        return { value: this.card?.discount };
    }

    get description(): StringField {
        return { value: this.card?.description };
    }

    get type(): StringField {
        let defaultValue = { value: "offerCardRegular" }
        if (this.itemIndex === 0) defaultValue.value = "offerCardWide"
        return defaultValue;
    }

    get disclaimer(): string {
        return this.card?.disclaimer;
    }

    get expiration(): StringField {
        return { value: this.card?.expiration };
    }

    get badge(): string {
        return this.card?.badge;
    }

    get expirationLabel(): StringField {
        return { value: this.card?.expirationLabel };
    }

    get image(): ImageField {
        return {
            value: {
                src: this.card?.assets?.[0].full,
                alt: this.card?.assets?.[0].alt
            }
        }
    };



    get buttonPrimary(): LinkField {
        return {
            value: {
                href: this.card?.button1?.url,
                title: this.card?.button1?.label
            }
        }
    }

    get buttonSecondary(): LinkField {
        return {
            value: {
                href: this.card?.button2?.url,
                title: this.card?.button2?.label
            }
        }
    }
}


